/* tslint:disable */
/* eslint-disable */
/**
 * Supply API Gateway
 * A REST API responsible to serve and compose all supply-related data available at Taster
 *
 * The version of the OpenAPI document: 1.63
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ProviderTypeFromJSON, ProviderTypeToJSON, } from './ProviderType';
/**
 * @export
 */
export const SearchProviderCategoriesParamsOrderByEnum = {
    Label: 'label',
    UnknownDefaultOpenApi: '11184809'
};
/**
 * Check if a given object implements the SearchProviderCategoriesParams interface.
 */
export function instanceOfSearchProviderCategoriesParams(value) {
    let isInstance = true;
    isInstance = isInstance && "providerType" in value;
    isInstance = isInstance && "locationUuids" in value;
    return isInstance;
}
export function SearchProviderCategoriesParamsFromJSON(json) {
    return SearchProviderCategoriesParamsFromJSONTyped(json, false);
}
export function SearchProviderCategoriesParamsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'isDeleted': !exists(json, 'is_deleted') ? undefined : json['is_deleted'],
        'providerType': ProviderTypeFromJSON(json['provider_type']),
        'label': !exists(json, 'label') ? undefined : json['label'],
        'locationUuids': json['location_uuids'],
        'conceptUuids': !exists(json, 'concept_uuids') ? undefined : json['concept_uuids'],
        'available': !exists(json, 'available') ? undefined : json['available'],
        'availableForOrdering': !exists(json, 'available_for_ordering') ? undefined : json['available_for_ordering'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'perPage': !exists(json, 'per_page') ? undefined : json['per_page'],
        'orderBy': !exists(json, 'order_by') ? undefined : json['order_by'],
        'desc': !exists(json, 'desc') ? undefined : json['desc'],
    };
}
export function SearchProviderCategoriesParamsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'is_deleted': value.isDeleted,
        'provider_type': ProviderTypeToJSON(value.providerType),
        'label': value.label,
        'location_uuids': value.locationUuids,
        'concept_uuids': value.conceptUuids,
        'available': value.available,
        'available_for_ordering': value.availableForOrdering,
        'page': value.page,
        'per_page': value.perPage,
        'order_by': value.orderBy,
        'desc': value.desc,
    };
}
